import React from 'react'
import styled from 'styled-components'
import {
  ROLE_ADMIN,
  ROLE_CITY_MANAGER,
  ROLE_SPY,
  ROLE_DISTRIBUTOR,
} from '../../shared/constants'

const CustomChip = ({ label = ROLE_DISTRIBUTOR, className = '' }) => {
  const Label = styled.span`
    min-width: 80px;
    line-height: 20px;
    border-radius: 10px;
    text-align: center;
    color: white;
    display: inline-block;
    background-color: green;
    font-size: 14px;
    &.red-label {
      background-color: red;
    }
    &.orange-label {
      background-color: orange;
    }
    &.blue-label {
      background-color: blue;
    }
  `
  if (label === ROLE_ADMIN) {
    return <Label className={'red-label'}>ADMIN</Label>
  }
  if (label === ROLE_CITY_MANAGER) {
    return <Label className={'orange-label'}>CM</Label>
  }
  if (label === ROLE_SPY) {
    return <Label className={'blue-label'}>SPY</Label>
  }
  return <Label className={className}>{label}</Label>
}

export default CustomChip
